import { css } from "@emotion/react";

export const ellipsesOverflowHelper = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
